<template>
  <el-container>
     <div class="navbarxx">
    

      <el-row   :gutter="24" > 
		
		 <el-col :span="6"><div class="grid-contentxx"> <cl-breadcrumb /> </div></el-col>
		
   		<el-col :span="18"><div class="right-menuxx"><cl-header ></cl-header></div></el-col>
		
    

    	</el-row>
     </div>

     
    <el-container>
      
      <cl-side-bar></cl-side-bar>
      <keep-alive>
        <router-view />
      </keep-alive>
    </el-container>
    <el-footer height="0"></el-footer>
  </el-container>
</template>

<script>

export default {
  components: {
   
    'cl-breadcrumb': () => import('./components/breadcrumb'),
    'cl-header': () => import('./components/header'),
    'cl-side-bar': () => import('./components/sidebar')
  }
}
</script>
<style scoped>

	.el-container {
		padding: 0px;
		margin: 0px;
    height: 100%;
    width: 100%;

	}

  .navbarxx {
  height: 26px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);
  }

  
   

   

  .grid-contentxx {
    border-radius: 4px;
    min-height: 26px;
  }
 .right-menuxx {
    float: right;
    border-radius: 4px;
    min-height: 26px;
    margin-right: 8px;
 }

</style>
